import { System } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/system_pb';
import { ResourceNameIdConverter } from '~/shared/models/ResourceNameIdConverter';

export class SystemLiteModel {
  name: string;

  title: string;

  id: string;

  location: string;

  constructor(system: System) {
    this.name = system.name;
    this.title = system.title;
    this.id = ResourceNameIdConverter.systemNameToId(system.name);
    this.location = system.location;
  }
}
